import { VideoCallRoomUserLogType } from 'src/lib/gql-client'
import { assertNever } from 'src/utils/assertNever'

export const videoCallRoomUserLogTypeToText = (
  logType: VideoCallRoomUserLogType,
) => {
  switch (logType) {
    case 'UserJoin':
      return '通話開始'
    case 'UserLeave':
      return '通話終了'
    default:
      assertNever(logType)
  }
}
